import LandingPage from "./LandingPage";
import "./index.css";

function App() {
  return <LandingPage />;
}

export default App;
